import { localDayISO } from './localDay.js'

export async function saveMemoryAnchor(client, { userId, fragranceId, title, note, date = localDayISO() }) {
  if (!userId || !fragranceId) throw new Error('Sign in and select a fragrance to save this memory.')
  const name = (title || '').trim()
  if (!name || name.length > 120) throw new Error('Memory title must be between 1 and 120 characters.')
  const { error } = await client.from('memory_anchors').insert({
    user_id: userId,
    fragrance_id: fragranceId,
    anchor_name: name,
    anchor_date: date || null,
    notes: (note || '').trim() || null,
  })
  if (error) throw error
}
